import React from "react";

/**
 * Repo images: WebP when the browser supports it, original file otherwise.
 * width and height reserve space so the image does not shove the page down.
 */
export default function LocalImage({
  src,
  webp,
  alt = "",
  width,
  height,
  className,
  style,
  priority = false,
}) {
  const image = (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={style}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      fetchPriority={priority ? "high" : "auto"}
    />
  );

  if (!webp) return image;

  return (
    <picture style={{ display: "contents" }}>
      <source srcSet={webp} type="image/webp" />
      {image}
    </picture>
  );
}
